import * as $ from 'jquery';
import * as ko from 'knockout';
import * as q from 'q';
import * as globalConfig from 'globalConfig';
import * as _ from 'underscore';

// Models
import { PaymentProviderTypes } from 'Content/ts/Enums/UniversalBasket/paymentProviderTypes';
import { IBillingDetailsMapped } from 'Content/ts/Models/Contact/Details/billingDetails';

class BasketRoutingService {
    getBasketPaymentRedirectConfiguration(paymentProvider: PaymentProviderTypes, isPartPayment: boolean = false, basketItemIds: number[] = null, billingDetails: IBillingDetailsMapped = null): any {
        var configuration = null;

        switch (paymentProvider) {
            case PaymentProviderTypes.PaymentExpress:
            case PaymentProviderTypes.GlobalOpenEdge:
            case PaymentProviderTypes.MonerisRedirect:
            case PaymentProviderTypes.CapitaV10:
            case PaymentProviderTypes.TdBankRedirect:
            case PaymentProviderTypes.VerifoneSCA:
            case PaymentProviderTypes.WPM:
                configuration = this.basketPaymentRedirectConfiguration(billingDetails);
                break;
            default:
                var promise = q.defer();
                promise.resolve({ RedirectUrl: this.getBasketPaymentUrl(paymentProvider) });
                configuration = promise.promise
                break;
        }
        
        return configuration;
    };

    basketPaymentRedirectConfiguration(billingDetails: IBillingDetailsMapped = null): any {
        return q($.ajax({
            url: globalConfig.Urls.BasketPaymentRedirect.GetRedirectConfiguration,
            type: "POST",
            data: ko.toJSON(billingDetails),
            dataType: "JSON",
            contentType: "application/JSON",
            cache: false
        }));
    };

    getBasketPaymentUrl(paymentProvider: PaymentProviderTypes) {
        var url = "";

        //A JS version of this file exists for the Journey/Join workflow, if new payment providers are added please ensure the JS version is also updated.
        switch (paymentProvider) {
            case PaymentProviderTypes.VerifoneDirectPost: url = globalConfig.Urls.Cart.PaymentDetails;
                break;
            case PaymentProviderTypes.TDBank: url = globalConfig.Urls.Cart.PayCart;
                break;
            case PaymentProviderTypes.Moneris: url = globalConfig.Urls.Cart.PayCart;
                break;
            case PaymentProviderTypes.Paymentus: url = this.getRedirectUrl().valueOf();
                break;
            case PaymentProviderTypes.GlobalOpenEdge: url = this.getRedirectUrl().valueOf();
                break;
            case PaymentProviderTypes.CapitaV10: url = this.basketPaymentRedirect().valueOf();
                break;
            case PaymentProviderTypes.PaymentExpress: url = this.getRedirectUrl().valueOf();
                break;
            case PaymentProviderTypes.PaymentTest: url = globalConfig.Urls.Cart.PayCart;
                break;
            case PaymentProviderTypes.TdBankRedirect: url = this.basketPaymentRedirect().valueOf();
                break;
            case PaymentProviderTypes.MonerisRedirect: url = this.basketPaymentRedirect().valueOf();
                break;
            default: url = "";
                break;
        }

        return url;
    }

    getRedirectUrl(): q.Promise<string> {
        var url = null;
        $.ajax({
            async: false,
            url: globalConfig.Urls.Cart.GetRedirectUrl,
            type: "GET",
            contentType: "application/JSON",
            success: function (response) {
                url = response;
            },
            cache: false
        });
        return url;
    };

    basketPaymentRedirect(): q.Promise<string> {
        var url = null;
        $.ajax({
            async: false,
            url: globalConfig.Urls.BasketPaymentRedirect.GetRedirectConfiguration,
            type: "POST",
            contentType: "application/JSON",
            success: function (response) {
                url = response.RedirectUrl;
            },
            cache: false
        });
        return url;
    };
};

var service = new BasketRoutingService();
export { service as BasketRoutingService };